/**
 * Форматирование карточки заказа (FE-150, FE-200).
 *
 * Подпись стадии, тон и главное действие переехали в `orderStage.ts`: карточка
 * теперь ведётся стадией воронки, а не статусом прогона (MVP_PRD §33.2). Здесь
 * остались две чистые функции, которые к таблице стадий отношения не имеют.
 */

/**
 * Абсолютная дата и время последней активности.
 *
 * Абсолютная, а не «2 часа назад» (S-11 п. 6): в списке из десяти заказов
 * относительное время не даёт сравнить их между собой.
 */
export function formatActivity(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

/** Сколько переговоров по заказу всего. Ноль карточка не показывает. */
export function totalNegotiations(counts: Record<string, number>): number {
  return Object.values(counts).reduce((sum, value) => sum + value, 0);
}
